export default "/images/profile_image_default.webp"